import React, { useState, useEffect, forwardRef } from "react";
import "./style.css";
import { getTickerTextField, isServiceHealthy } from "../../utils/API";
import withTicker from "../../redux/HOC/withTicker";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import withRefreshSecMaster from "../../redux/HOC/withRefreshSecMaster";
import { hasAccess, mapRowId } from "../../common/commonFunctions";
import SecMasterGrid from "./Grid";
import { useNavigate } from "react-router";
import Snackbar from "@mui/material/Snackbar";
import { constants, EndPoint, messages } from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import _ from "lodash";
import { Column, exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { Button, Card, CardContent } from "@mui/material";
import excel from "../../assets/images/excel.svg";
import { ToastContainer, toast } from "react-toastify";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import axios from "axios";
import moment from "moment";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import { pageConstant } from "../../config/pageConstant";
import swal from "sweetalert";

const SecMaster = ({
  tickerSet,
  setRefreshSecMaster,
  refreshSecMaster,
}: any) => {
  const [secmaster, setSecmaster] = useState<Array<any>>([])
  const [initSecmaster, setInitSecmaster] = useState<Array<any>>([])
  const [refData, setRefData] = useState<any>(null);
  const [gridApiSec, setGridApiSec] = useState<any>(null);
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [heightAG_1] = useState(75);
  const [isDuplicateTicker, setDuplicateTicker] = useState<boolean>(false)
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] = useState<boolean>(false)
  const accessToken = window.localStorage.getItem('refreshtoken')
  const headers = {
    'Content-Type': 'application/json'
  }
  axios.defaults.headers.common = { Authorization: `Bearer ${accessToken}` }
  const accountId = window.localStorage.getItem('activeAccountCode')
  const [isAddDisabled, setIsAddDisabled] =  useState<boolean>(false)
  const [isSaveDisabled, setIsSaveDisabled] =  useState<boolean>(true)
  const [isCancelDisabled, setIsCancelDisabled] = useState<boolean>(true)
  const [isOverrideFilter, setIsOverrideFilter] = useState<boolean>(false)

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const secMaster = async () => {
    setIsAddDisabled(false)
    setIsSaveDisabled(true)
    setIsCancelDisabled(true)
    let getSecMasterRes: any = "";
    try {
      getSecMasterRes = await getTickerTextField();
      if (!getSecMasterRes) {
        setOpen(true);
        setSnackbarMessage(messages.TickerDownMessage);
      }
      if (getSecMasterRes?.status === 200) {
        const tickerdataApi = await getSecMasterRes.json();
        const mappedRows = mapRowId([...tickerdataApi])
        const rows = mappedRows?.map((row: any)=>{
          return {
            ...row,
            isOverride: row?.isOverride?'Yes':'No'
          }
        })
        if(isOverrideFilter){
          const filtered = rows?.filter((s: any)=> s?.isOverride === 'Yes')
          setSecmaster(filtered);
        }else{
          setSecmaster(rows);
        }
        
        setInitSecmaster(rows)
        
        tickerSet(tickerdataApi);
      } else if (getSecMasterRes?.status === 401) {
        navigate("/signin");
      }
    } catch (err) {
      setSecmaster([]);
      setInitSecmaster([])
    }
  };

 
  const refreshGrid = () => {
    secMaster();
    let CurrentDateforRefresh: any = new Date();
    setRefreshSecMaster(
      CurrentDateforRefresh.toLocaleString("en-US", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );
    setIsAddDisabled(false)
    setIsSaveDisabled(true)
    setIsCancelDisabled(true)
  };

  const onGridRefresh = ()=>{
    setSecmaster([])
    setInitSecmaster([])
    refreshGrid();
  }


  useEffect(() => {
    getServiceHealthCheck();
  }, []);


  const onFilterTextChange = _.debounce((e: any) => {
    gridApiSec?.setQuickFilter(e.target.value);
  }, 800);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refData?.current?.api?.getSheetDataForExcel?.({
        sheetName: "sec-master",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "sec-master.xlsx",
    });
  }

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("secmaster-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 22 : offsetHeight + 12;

    return "calc(100% - " + divHeight + "px)";
  };

  const onSave = () => {
    const insertRows = [...secmaster]?.filter((x: any) => x.isNewRowInsert)
    const updateRows = [...secmaster]?.filter((x: any) => x.isRowUpdated)

    if (_.isArray(insertRows) && insertRows?.length > 0) {
      const validRows = insertRows?.filter((row: any) => isValidRateRow(row))

      if (_.isArray(validRows) && validRows?.length > 0) {
        saveNewSecMasterData(validRows)
      }
    }

    if (_.isArray(updateRows) && updateRows?.length > 0) {
      const validRows = updateRows?.filter((row: any) => isValidRateRow(row))
      if (_.isArray(validRows) && validRows?.length > 0) {
        updateSecMasterData(validRows)
      }
    }
  }

  const onAddEvent = () => {
    setSecmaster((previousRows: any) => {
      const obj = {
        cins: '',
        cusip: '',
        date: moment().format("YYYY-MM-DD"),
        isin: '',
        name: '',
        price: 0,
        sm_id: 0,
        ticker: '',
        updatedTime: '',
        bb_ticker: '',
        isNewRowInsert: true,
        id: previousRows?.length + 1
      }

      return [obj, ...previousRows]
    })
    setIsAddDisabled(true)
    setIsSaveDisabled(false)
    setIsCancelDisabled(false)
  }

  const onCellChange = (row: any, changeValue: any, column: Column) => {
    row.isRowUpdated = !row?.isNewRowInsert
    if(row.isRowUpdated){
      setIsAddDisabled(true)
      setIsSaveDisabled(false)
      setIsCancelDisabled(false)
    }
    switch (column?.getColId()) {
      case 'ticker':
        row.isTickerUpdated = true
        break
      case 'cusip':
        row.isCusipUpdated = true
        break
      case 'price':
        {
          row.isPriceUpdated = true
          row.price = +changeValue?.toFixed(2)
        break
        }
      case 'name':
        row.isNameUpdated = true
        break
      case 'date':
        row.isDateUpdated = true
        break
      case 'isin':
        row.isIsInUpdated = true
        break

      default:
        break
    }

    setSecmaster((previousRows: any) => {
      const newRows = [...previousRows]
      const ticker = [...previousRows]?.filter(
        (x: any) =>
          x?.ticker?.toUpperCase() === row?.ticker?.toUpperCase() ||
          x?.cusip?.toUpperCase() === row?.cusip?.toUpperCase()
      )
      const isDuplicateTicker = ticker?.length >= 2
      setDuplicateTicker(isDuplicateTicker)
      if (isDuplicateTicker) {
        toast?.error('Duplicate Ticker or Cusip are not allowed')
      }
      const ind = newRows?.findIndex((x: any) => x?.id === row?.id)
      if (ind >= 0) {
        newRows[ind] = row
      }


      return newRows
    })
  }

  const onCancel = () => {
    refreshGrid()
    setIsAddDisabled(false)
  }

  const isValidRateRow = (row: any) => {
    return (
      row?.ticker &&
      !_.isEmpty(row?.ticker) &&
      row?.cusip &&
      !_.isEmpty(row?.cusip) &&
      row?.price &&
      _.isNumber(row?.price)
    )
  }

  const saveNewSecMasterData = async (rows: any) => {
    try {
      setDoShowFullScreenLoader(true)
      const req = [...rows]?.map(row => {
        return {
          bb_ticker: '',
          cins: ' ',
          cusip: row?.cusip,
          date: moment(row?.date)?.format('YYYY-MM-DD'),
          isin: row?.isin,
          name: row?.name,
          price: row?.price,
          sm_id: row?.sm_id,
          ticker: row?.ticker?.toUpperCase(),
          updatedTime: ''
        }
      })
      const raw = JSON.stringify(req)
      await axios
        .post(
          `${serviceAPIMapping['SECMASTER-SERVICE'].apiRouteURL}${EndPoint.saveSecMasterDetails}?account_id=${accountId}`,
          raw,
          { headers: headers }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true)
            setSnackbarMessage(messages.TickerDownMessage)
          } else if (!_.isUndefined(response) && response?.status === 200) {
            toast.success('Sec master data saved successfully')
            secMaster()
          } else if (response?.status === 401) {
            // logout(channel)
          } else {
            swal({
              icon: "error",
              text: `Failed to save Sec master data`,
              dangerMode: false,
              closeOnClickOutside: false,
            });
          }
        })
    } catch (err) {
      swal({
        icon: "error",
        text: `Failed to save Sec master data`,
        dangerMode: false,
        closeOnClickOutside: false,
      });
      secMaster()
    } finally {
      setDoShowFullScreenLoader(false)
    }
  }

  const updateSecMasterData = async (rows: any) => {
    try {
      setDoShowFullScreenLoader(true)
      const req = [...rows]?.map((row: any) => {
        return {
          bb_ticker: '',
          cins: ' ',
          cusip: row?.cusip,
          date: moment(row?.date)?.format('YYYY-MM-DD'),
          isin: row?.isin,
          name: row?.name,
          price: row?.price,
          sm_id: row?.sm_id,
          ticker: row?.ticker,
          updatedTime: ''
        }
      })
      const raw = JSON.stringify(req)

      await axios
        .post(
          `${serviceAPIMapping['SECMASTER-SERVICE'].apiRouteURL}${EndPoint.updateSecMasterDetails}?account_id=${accountId}`,
          raw,
          {
            headers: headers
          }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true)
            setSnackbarMessage(messages.serviceDownMessage)
          } else if (!_.isUndefined(response) && response?.status === 200) {
            toast.success('Sec master data updated successfully')
            secMaster()
          } else if (response?.status === 401) {
            // logout(channel)
          } else {
            swal({
              icon: "error",
              text: `Failed to update Sec master data`,
              dangerMode: false,
              closeOnClickOutside: false,
            });
          }
        })
    } catch (err: any) {
        swal({
          icon: "error",
          text: `Update is failed with response status - ${
            err?.status
          } and error ${err?.error}`,
          dangerMode: false,
          closeOnClickOutside: false,
        });
      secMaster()
    } finally {
      setDoShowFullScreenLoader(false)
    }
  }

  const getServiceHealthCheck = async () => {
      await isServiceHealthy(
        `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
      ).then((response: any) => {
        if (!response?.ok || response?.status === 503) {
          setSnackbarMessage(`${messages.TickerDownMessage}`);
          setOpen(true);
        } else {
           refreshGrid();
        }
      });
    };

    const onOverrideFilter = (isOverride: boolean)=>{
      if(isOverride){
        const filtered = [...initSecmaster]?.filter((s: any)=>s?.isOverride === 'Yes')

        setSecmaster(filtered)
      }
      else{
        setSecmaster([...initSecmaster])
      }
    }

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {doShowFullScreenLoader && <SpinnerFullScreen />}
      <div className="ps-3 mt-1" id="secmaster-title">
        Secmaster
      </div>
      <Card style={{ height: getCardHeight() }} className="m-1">
        <CardContent className="h-100 w-100  px-2 pt-1">
          <div className="minimizeIconforLoan">
            <div
              className="globalfiltermaindivSec mb-1"
              style={{ marginLeft: "0.3rem", marginTop: "0.2rem" }}
            >
              <input
                type="search"
                placeholder="Global search..."
                id="filter-text-box-sec"
                onInput={onFilterTextChange}
              />
              <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
            </div>
            
                  
            <div className="form-check form-switch d-flex align-items-center justify-content-end ms-4 div-wrapper-37">
              <input
                checked={isOverrideFilter}
                onChange={() => {
                   const isShowOverride = !isOverrideFilter;
                   setIsOverrideFilter(isShowOverride);
                   onOverrideFilter?.(isShowOverride);
                }}
                className={`form-check-input me-2 cursor-pointer`}
                type="checkbox"
                role="switch"
                id="showOverride"
                title="Show only override"
                style={{ fontSize: "large" }}
              />
              <label
                className="form-check-label text-nowrap mb-0 align-self-center mt-1"
                htmlFor="showOverride"
                style={{ fontSize: "medium", marginLeft: "4px" }}
              >
                Show Only Override
              </label>
            </div>
          
                
            <div className='col d-flex justify-content-end align-items-center'>
              <Button
                className={(isAddDisabled || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`]))?'mx-1 app-button-disable py-0' : 'mx-1 app-button py-0'}
                size='small'
                variant='contained'
                onClick={onAddEvent}
                disabled={isAddDisabled || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`])}
              >
                Add
              </Button>
              <Button
                size='small'
                variant='contained'
                className={(isSaveDisabled || isDuplicateTicker || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`]))?'mx-1 app-button-disable py-0' : 'mx-1 app-button py-0'}
                disabled={
                  isSaveDisabled || isDuplicateTicker || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`])
                }
                onClick={onSave}
              >
                Save
              </Button>
              <Button
                className={isCancelDisabled || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`])?'mx-1 app-button-disable py-0' : 'mx-1 app-button py-0'}
                size='small'
                variant='contained'
                onClick={onCancel}
                disabled={isCancelDisabled || !hasAccess([`${pageConstant?.SECMASTER}_ADMIN`, `${pageConstant?.SECMASTER}_RW`])}
              >
                Cancel
              </Button>
            </div>
         
            <div className="d-flex align-items-center">
              <span
                    className="borrowExceldnld float-start"
                    onClick={onExcelExport}
                    title="Download Excel"
                  >
                    <img
                      src={excel}
                      alt=""
                      style={{
                        height: "1.8rem",
                        width: "1.8rem",
                        cursor: "pointer",
                      }}
                    />
                  </span>
              <div
                className="d-flex justify-content-end align-items-center cursor-pointer ms-0 pl-0"
                onClick={onGridRefresh}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                />
                <div className="refreshsettimedateContract">
                  <div>Last updated on: </div>
                  <div>{refreshSecMaster}</div>
                </div>
              </div>
            </div>
          </div>
          <div id="rates-dashboard" className="h-100 pb-3">
            <SecMasterGrid
              rowData={secmaster}
              height={heightAG_1}
              type="SecMaster"
              getBtnRef={(gridRef: any) => {
                setRefData(gridRef);
              }}
              getGridApi={(gridApi: any) => {
                setGridApiSec(gridApi);
              }}
              onCellChange={(data: any, value: any, column: Column) => {
                onCellChange(data, value, column)
              }}
            />
          </div>
           <ToastContainer />
        </CardContent>
      </Card>
    </>
  );
};

export default withRefreshSecMaster(withTicker(SecMaster));
